import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const Heading = styled.span`
  color: #4585ff;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;

  &:after {
    content: "|";

    margin-inline: 6px;

    color: #000000;
  }
`;
export const Summary = styled.span`
  color: #000000;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;
